import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiTrendingUp } from 'react-icons/fi';
import Hero from '../components/sections/Hero';
import SEO from '../components/common/SEO';
import SafeIcon from '../components/common/SafeIcon';
import { caseStudies } from '../data/caseStudies';

const CaseStudiesPage = () => {
  return (
    <>
      <SEO 
        title="Success Stories | Alberta SEO Pro" 
        description="See how we've helped Alberta HVAC, Electrical, and Construction companies dominate local search and increase revenue." 
      />
      
      <Hero 
        title="Real Results for Real Businesses" 
        subtitle="We don't just track rankings. We track revenue. Explore our portfolio of Alberta market dominance." 
      />

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {caseStudies.map((study, i) => (
              <motion.div 
                key={study.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className="group bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:border-orange-500 hover:bg-white hover:shadow-2xl transition-all"
              >
                <div className="flex justify-between items-start mb-6">
                  <span className="text-xs font-bold px-3 py-1 bg-white border border-slate-200 rounded-full text-slate-500 uppercase tracking-tighter">
                    {study.industry}
                  </span>
                  <div className="w-10 h-10 bg-orange-600 text-white rounded-lg flex items-center justify-center shadow-lg shadow-orange-600/20">
                    <SafeIcon icon={FiTrendingUp} />
                  </div>
                </div>
                <h4 className="text-sm font-black text-orange-600 mb-2">{study.client}</h4>
                <h3 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-orange-600 transition-colors">
                  {study.title}
                </h3>
                <p className="text-sm text-slate-600 mb-8 line-clamp-3">
                  {study.problem}
                </p>
                
                <div className="grid grid-cols-3 gap-4 mb-8 pt-6 border-t border-slate-200">
                  {study.stats.map((stat, idx) => (
                    <div key={idx}>
                      <span className="block text-lg font-bold text-slate-900">{stat.value}</span>
                      <span className="block text-[10px] text-slate-400 uppercase font-black">{stat.label}</span>
                    </div>
                  ))}
                </div>

                <Link 
                  to={`/case-studies/${study.id}`}
                  className="flex items-center gap-2 text-orange-600 font-bold text-sm"
                >
                  View Full Strategy <SafeIcon icon={FiArrowRight} />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to be our next success story?</h2>
          <p className="text-slate-400 mb-10 text-lg">Let's build a custom strategy to dominate your local Alberta market.</p>
          <Link to="/audit" className="px-8 py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-bold transition-all inline-flex items-center gap-2">
            Get Your Free Audit <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>
      </section>
    </>
  );
};

export default CaseStudiesPage;